import React from 'react';
import {
  Typography, styled, Box, Link,
} from '@material-ui/core';
import { usePostHog } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { OnboardingParams } from '../../types';

import { getProductSupportEmail } from '@/utils/productHelpers';
import { getProgram } from '@/utils/posthog';

const FooterContainer = styled(Box)({
  display: 'flex',
  padding: '40px 0',
  width: '100%',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { product } = useParams<OnboardingParams>();
  const supportEmail = getProductSupportEmail(product);

  const { t } = useTranslation();
  const posthog = usePostHog();

  return (
    <FooterContainer>
      <Typography variant="caption" color="textSecondary" style={{ paddingBottom: 24 }}>
        {t('footer.if_you_need_support')}
        {' '}
        <Link
          href={`mailto:${supportEmail}`}
          underline="always"
          color="inherit"
          onClick={() => { posthog?.capture('SupportContacted', { program: getProgram(product) }); }}
        >
          {supportEmail}
        </Link>
      </Typography>
      <Typography variant="caption" color="textSecondary">
        ©
        {' '}
        {currentYear}
        {' '}
        Big Health
      </Typography>
      <Typography variant="caption" color="textSecondary" style={{ paddingBottom: 16 }}>
        <Link
          href={t('footer.privacy_notice.link')}
          color="inherit"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.privacy_notice.label')}
        </Link>
        {' | '}
        <Link
          href={t('footer.terms_of_use.link')}
          color="inherit"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.terms_of_use.label')}
        </Link>
        {' | '}
        <Link
          component="button"
          color="inherit"
          onClick={(e) => {
            e.preventDefault();
            window.transcend?.toggleConsentManager();
          }}
        >
          {t('footer.cookie_preferences')}
        </Link>
      </Typography>
    </FooterContainer>
  );
};
